<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" :title="title" centered destroyOnClose width="60%">
    <a-space style="margin-top: -22px">
      <a-input-search v-model="query['no']" :placeholder="$t('business.label.no')" style="width: 200px" @pressEnter="search" @search="search"/>
      <a-select v-model="query['containerType.id']" :placeholder="$t('business.label.containerType')" allowClear style="width: 200px" @change="search">
        <a-select-option v-for="d in containerTypes" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      :height="height"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="40"/>
      <vxe-column field="no" title="business.label.no"/>
      <vxe-column field="name" title="business.label.name"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:operationTypes}" field="operationType" title="business.label.operationType"/>
      <vxe-column field="taskId" title="business.label.taskId"/>
      <vxe-column field="currentPosition.no" title="business.label.currentPosition"/>
      <vxe-column field="lastPosition.no" title="business.label.lastPosition"/>
      <vxe-column field="destination.no" title="business.label.destination"/>
      <vxe-column field="carrier.no" title="business.label.carrier"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="physical" title="business.label.physical" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { convert } from '@/utils/util'

export default {
  name: 'ContainerModal',
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    title: {
      type: String,
      default: '容器检索'
    }
  },
  data() {
    return {
      show: true,
      page: 1,
      size: 15,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      operationTypes: [],
      containerTypes: [],
      query: {
        'no': '',
        'containerType.id': ''
      },
      args: null,
      record: undefined,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.6)
    }
  },
  created() {
    findEnum('OperationType').then(res => {
      if (res.success) {
        this.operationTypes = res.result
      }
    })
    findAll('containerTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.containerTypes = res.result
      }
    })
  },
  methods: {
    convert,
    init(args) {
      this.query = {
        'no': '',
        'name': ''
      }
      this.data = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      this.loading = true
      this.getData()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('containerFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>